import React from 'react'
import PropTypes from 'prop-types'
import S3 from 'aws-sdk/clients/s3'
import cloneDeep from 'lodash/cloneDeep'
import awsConfig from 'cms/config/aws'
import View from './View'
import './styles.css'

const s3 = new S3(awsConfig)

class S3Thumbnails extends React.Component {
  baseUrl = 'https://s3-us-west-1.amazonaws.com'
  bucket = 'healthfulinspired'
  region = 'us-west-1'

  beginUpload = ({ thumbnails, updateThumbnailState }) => () => {
    const { files } = this.fileInputRef
    if (!thumbnails.length && !files.length) {
      return false
    }
    // eslint-disable-next-line
    const bucketFolder = document.getElementById('bucketFolder').value
    // eslint-disable-next-line
    let keyInputValue = document.getElementById('keyInputRef').value
    const newThumbnails = cloneDeep(thumbnails)
    let counter = 0
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const params = {
        Bucket: this.bucket,
        Key: `${bucketFolder}/${keyInputValue}/${file.name}`,
        Body: file,
        ContentType: file.type, // MIME
        Metadata: {
          // custom fields show up as x-amz-meta-[custom_field] as keys in object metadata
          // postDate: new Date().toString(),
        },
      }
      this.uploadFile({ params })
        .then((data) => {
          counter++
          const link = data.Location
          const key = file.name
          newThumbnails[key].link = link
          if (counter === files.length) {
            console.log('Uploaded: ' + file.name)
            updateThumbnailState(newThumbnails)
          }
        })
        .catch((error) => {
          console.error('Failed uploading: ' + file.name)
          console.error(error)
        })
    }
  }

  createThumbnail = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        resolve(e.target.result)
      }
      fileReader.onerror = (err) => {
        reject(err)
      }
      fileReader.readAsDataURL(file)
    })
  }

  handleUploadImageDragOver = (e) => {
    e.dataTransfer.dropEffect = 'copy'
  }

  onFileInputChange = (insert) => (e) => {
    e.persist()
    const { files } = e.target
    const thumbnails = {}
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      if (/image\//.test(file.type)) {
        this.createThumbnail(file)
          .then((src) => {
            const key = file.name
            thumbnails[key] = {
              src,
              name: file.name,
              title: file.name,
              size: this.formatBytes(file.size),
              link: null,
            }
            if (i + 1 === files.length) {
              setTimeout(() => {
                insert(thumbnails)
              }, 50)
            }
          })
          .catch((error) => {
            console.error(error)
          })
      }
    }
  }

  formatBytes = (bytes, decimals) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }

  uploadFile = ({ params }) => {
    return new Promise((resolve, reject) => {
      s3.upload(params, (error, data) => {
        if (error) {
          reject(error)
        } else {
          resolve(data)
        }
      })
    })
  }

  render() {
    return (
      <View
        onFileInputChange={this.onFileInputChange}
        onUploadImageDragOver={this.handleUploadImageDragOver}
        beginUpload={this.beginUpload}
        fileInputRef={(e) => (this.fileInputRef = e)}
        keyInputRef={(e) => (this.keyInputRef = e)}
        {...this.state}
        {...this.props}
      />
    )
  }
}

S3Thumbnails.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
}

export default S3Thumbnails



// WEBPACK FOOTER //
// ./src/cms/widgets/S3Thumbnails/index.js